export function getLocale(locale) {
  const userLocale = locale ?? 'DE_DE'
  const language = userLocale.split('_')[0]
  const country = userLocale.split('_')[1]
  return language.toLowerCase() + '-' + country.toUpperCase()
}
